import { injectEmptyTimelineGaps } from '../mergeFaceTimeline.js';

/** @typedef {{ startTime: number, endTime: number }} StableFragment */
/** @typedef {{ trackId: number, faceData: object, frameCount: number }} TimelineFaceSegment */

/**
 * 每个 stableFragment 对应一块；片段间空隙补 `segments: []`。
 * @param {StableFragment[]} fragments
 * @param {Map<number, TimelineFaceSegment[]>} segmentsByFragIndex
 * @param {number} timeMin
 * @param {number} timeMax
 */
export function buildTimelineBlocksFromFragments(fragments, segmentsByFragIndex, timeMin, timeMax) {
    const blocks = fragments.map((frag, fragIndex) => ({
        startTime: frag.startTime,
        endTime: frag.endTime,
        segments: (segmentsByFragIndex.get(fragIndex) ?? []).map(s => ({
            trackId: s.trackId,
            faceData: { ...s.faceData },
            frameCount: s.frameCount,
        })),
    }));

    blocks.sort((a, b) => (a.startTime !== b.startTime ? a.startTime - b.startTime : a.endTime - b.endTime));
    return injectEmptyTimelineGaps(blocks, timeMin, timeMax);
}
